import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Users, Clock, UserCheck, Key } from 'lucide-react';

export function AdminStatsCards({ stats }) {
  if (!stats) return null;
  const items = [
    { icon: Users, color: 'blue', value: stats.total_users, label: 'Total Users' },
    { icon: Clock, color: 'yellow', value: stats.pending_users, label: 'Pending' },
    { icon: UserCheck, color: 'green', value: stats.approved_users, label: 'Approved' },
    { icon: Key, color: 'purple', value: stats.total_activation_codes, label: 'Codes' },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {items.map(({ icon: Icon, color, value, label }) => (
        <Card key={label}>
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg bg-${color}-500/20`}>
                <Icon className={`h-5 w-5 text-${color}-500`} />
              </div>
              <div>
                <p className="text-2xl font-bold">{value}</p>
                <p className="text-sm text-muted-foreground">{label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
